// store/analyticsApi/analyticsThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as analyticsApi from "@/api/analyticsApi";

// ==================== DEPARTMENT ANALYTICS ====================

export const fetchDepartmentPerformance = createAsyncThunk(
  "analytics/fetchDepartmentPerformance",
  async ({ periodDays = 30 } = {}, { rejectWithValue }) => {
    try {
      const data = await analyticsApi.getDepartmentPerformance(periodDays);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ==================== TASK ANALYTICS ====================

export const fetchTaskRejections = createAsyncThunk(
  "analytics/fetchTaskRejections",
  async ({ periodDays = 30, topN = 10 } = {}, { rejectWithValue }) => {
    try {
      const data = await analyticsApi.getTaskRejections(periodDays, topN);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchTaskTrends = createAsyncThunk(
  "analytics/fetchTaskTrends",
  async ({ period = "daily", days = 30 } = {}, { rejectWithValue }) => {
    try {
      const data = await analyticsApi.getTaskTrends(period, days);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchTaskComplexity = createAsyncThunk(
  "analytics/fetchTaskComplexity",
  async ({ periodDays = 30 } = {}, { rejectWithValue }) => {
    try {
      const data = await analyticsApi.getTaskComplexity(periodDays);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ==================== WORKLOAD ANALYTICS ====================

export const fetchWorkloadDistribution = createAsyncThunk(
  "analytics/fetchWorkloadDistribution",
  async (_, { rejectWithValue }) => {
    try {
      const data = await analyticsApi.getWorkloadDistribution();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ==================== EVENT ANALYTICS ====================

export const fetchEventEngagement = createAsyncThunk(
  "analytics/fetchEventEngagement",
  async ({ periodDays = 30 } = {}, { rejectWithValue }) => {
    try {
      const data = await analyticsApi.getEventEngagement(periodDays);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ==================== APPROVAL ANALYTICS ====================

export const fetchApprovalChainAnalysis = createAsyncThunk(
  "analytics/fetchApprovalChainAnalysis",
  async (_, { rejectWithValue }) => {
    try {
      const data = await analyticsApi.getApprovalChainAnalysis();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ==================== TIME ANALYTICS ====================

export const fetchTimeAnalysis = createAsyncThunk(
  "analytics/fetchTimeAnalysis",
  async ({ periodDays = 30 } = {}, { rejectWithValue }) => {
    try {
      const data = await analyticsApi.getTimeAnalysis(periodDays);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ==================== COMPREHENSIVE ANALYTICS ====================

export const fetchAnalyticsSummary = createAsyncThunk(
  "analytics/fetchAnalyticsSummary",
  async ({ periodDays = 30 } = {}, { rejectWithValue }) => {
    try {
      const data = await analyticsApi.getAnalyticsSummary(periodDays);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ==================== USER PERFORMANCE ANALYTICS ====================

export const fetchMyPerformanceDetails = createAsyncThunk(
  "analytics/fetchMyPerformanceDetails",
  async ({ periodDays = 30 } = {}, { rejectWithValue }) => {
    try {
      const data = await analyticsApi.getMyPerformanceDetails(periodDays);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
